'use client';

import '@ui5/webcomponents/dist/List.js';
import { ListSeparators, ListMode, ListGrowingMode } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `List` component allows displaying a list of items, advanced keyboard handling support for navigating between items, and predefined modes to improve the development efficiency.
 *
 * The `List` is a container for the available list items:
 *
 * *   `StandardListItem`
 * *   `CustomListItem`
 * *   `GroupHeaderListItem`
 *
 *
 *
 * To benefit from the built-in selection mechanism, you can use the available selection modes, such as `SingleSelect`, `MultiSelect` and `Delete`.
 *
 * Additionally, the `List` provides header, footer, and customization for the list item separators.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-List)
 */
const List = withWebComponent('ui5-list', ['accessibleName', 'accessibleNameRef', 'accessibleRole', 'busyDelay', 'footerText', 'growing', 'headerText', 'mode', 'noDataText', 'separators'], ['busy', 'indent'], ['header'], ['item-click', 'item-close', 'item-delete', 'item-toggle', 'load-more', 'selection-change']);
List.displayName = 'List';
List.defaultProps = {
  accessibleRole: 'list',
  busyDelay: 1000,
  growing: ListGrowingMode.None,
  mode: ListMode.None,
  separators: ListSeparators.All
};
export { List };